import Typography from '@material-ui/core/Typography'
import React from 'react'

export const Copyright = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {'Copyright © '}
    The Daily Dose {`${new Date().getFullYear()}`}
  </Typography>
)
